/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { Favorite } from '../model/favorite';
import { FavoriteType } from '../model/favoriteType';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class KoguiFavoriteService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * Elimna nueva entrada en la lista de favoritos.
     * Elimina Favorito
     * @param usuario El usuario de kogui.
     * @param type El tipo del favorito
     * @param id El id del favorito
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling deleteKoguiByUsuarioFavoritosByTypeById.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling deleteKoguiByUsuarioFavoritosByTypeById.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteKoguiByUsuarioFavoritosByTypeById.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.delete<any>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/favoritos/${encodeURIComponent(String(type))}/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene una lista de favoritos por tipo.
     * Get Favoritos por tipo.
     * @param usuario El usuario de kogui.
     * @param xFcmtoken 
     * @param target Especifica que se desea obtener el target del favorito.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioFavoritosAll(usuario: string, xFcmtoken?: string, target?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<Favorite>>;
    public getKoguiByUsuarioFavoritosAll(usuario: string, xFcmtoken?: string, target?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Favorite>>>;
    public getKoguiByUsuarioFavoritosAll(usuario: string, xFcmtoken?: string, target?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Favorite>>>;
    public getKoguiByUsuarioFavoritosAll(usuario: string, xFcmtoken?: string, target?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioFavoritosAll.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (target !== undefined && target !== null) {
            queryParameters = queryParameters.set('target', <any>target);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Favorite>>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/favoritos/all/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene una lista de favoritos por tipo.
     * Get Favoritos por tipo.
     * @param usuario El usuario de kogui.
     * @param type El tipo del favorito
     * @param xFcmtoken 
     * @param target Especifica que se desea obtener el target del favorito.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioFavoritosByType(usuario: string, type: FavoriteType, xFcmtoken?: string, target?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<Favorite>>;
    public getKoguiByUsuarioFavoritosByType(usuario: string, type: FavoriteType, xFcmtoken?: string, target?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Favorite>>>;
    public getKoguiByUsuarioFavoritosByType(usuario: string, type: FavoriteType, xFcmtoken?: string, target?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Favorite>>>;
    public getKoguiByUsuarioFavoritosByType(usuario: string, type: FavoriteType, xFcmtoken?: string, target?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioFavoritosByType.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getKoguiByUsuarioFavoritosByType.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (target !== undefined && target !== null) {
            queryParameters = queryParameters.set('target', <any>target);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Favorite>>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/favoritos/${encodeURIComponent(String(type))}/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene informacion sobre un favorito.
     * Obtien informacion sobre un favorito.
     * @param usuario El usuario de kogui.
     * @param type El tipo del favorito
     * @param id El id del favorito
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Favorite>;
    public getKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Favorite>>;
    public getKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Favorite>>;
    public getKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioFavoritosByTypeById.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling getKoguiByUsuarioFavoritosByTypeById.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getKoguiByUsuarioFavoritosByTypeById.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Favorite>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/favoritos/${encodeURIComponent(String(type))}/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una nueva entrada en la lista de favoritos.
     * Create Favorito
     * @param usuario El usuario de kogui.
     * @param type El tipo del favorito
     * @param id El id del favorito
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Favorite>;
    public postKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Favorite>>;
    public postKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Favorite>>;
    public postKoguiByUsuarioFavoritosByTypeById(usuario: string, type: FavoriteType, id: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling postKoguiByUsuarioFavoritosByTypeById.');
        }
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling postKoguiByUsuarioFavoritosByTypeById.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling postKoguiByUsuarioFavoritosByTypeById.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.post<Favorite>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/favoritos/${encodeURIComponent(String(type))}/${encodeURIComponent(String(id))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
